import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { RetailerInformation } from "web/types/serializers";

export interface RetailerInformationSlice {
    retailer: RetailerInformation | null;
    isLoading: boolean;
}

const initialState: RetailerInformationSlice = {
    retailer: null,
    isLoading: false,
};

const retailerInformationSlice = createSlice({
    name: "retailerInformation",
    initialState,
    reducers: {
        setRetailerInformation(state, action: PayloadAction<RetailerInformation>): void {
            state.retailer = action.payload;
            state.isLoading = false;
        },

        setRetailerInformationLoading(state, action: PayloadAction<boolean>): void {
            state.isLoading = action.payload;
        },

        clearRetailerInformation(state): void {
            state.retailer = null;
            state.isLoading = false;
        },
    },
});

export const { setRetailerInformation, setRetailerInformationLoading, clearRetailerInformation } =
    retailerInformationSlice.actions;

export default retailerInformationSlice.reducer;
